import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ContentSection } from '../components/ContentSection';
import { BonusSection } from '../components/BonusSection';
import { AudienceSection } from '../components/AudienceSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { UpsellSection } from '../components/UpsellSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-rose-200 selection:text-rose-900" data-id="element-313">
      <main data-id="element-314">
        <HeroSection data-id="element-315" />
        <ProblemSection data-id="element-316" />
        <SolutionSection data-id="element-317" />
        <ContentSection data-id="element-318" />
        <BonusSection data-id="element-319" />
        <AudienceSection data-id="element-320" />
        <TestimonialsSection data-id="element-321" />
        <UpsellSection data-id="element-322" />
        <PricingSection data-id="element-323" />
        <FAQSection data-id="element-324" />
        <FinalCTASection data-id="element-325" />
      </main>
      <Footer data-id="element-326" />
    </div>;
}